<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content [formGroup]="depositProductIncentiveForm" class="layout-column">
  <mat-form-field>
    <mat-label>{{ 'labels.inputs.Attribute' | translate }}</mat-label>
    <mat-select formControlName="attributeName" required>
      @for (attributeName of attributeNameData; track attributeName) {
        <mat-option [value]="attributeName.id">
          {{ attributeName.value }}
        </mat-option>
      }
    </mat-select>
    <mat-error>
      {{ 'labels.inputs.Attribute' | translate }} {{ 'labels.commons.is' | translate }}
      <strong>{{ 'labels.commons.required' | translate }}</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'labels.inputs.Condition' | translate }}</mat-label>
    <mat-select formControlName="conditionType" required>
      @for (conditionType of conditionTypeData; track conditionType) {
        <mat-option [value]="conditionType.id">
          {{ conditionType.value }}
        </mat-option>
      }
    </mat-select>
    <mat-error>
      {{ 'labels.inputs.Condition' | translate }} {{ 'labels.commons.is' | translate }}
      <strong>{{ 'labels.commons.required' | translate }}</strong>
    </mat-error>
  </mat-form-field>

  @if (depositProductIncentiveForm.value.attributeName) {
    <mat-form-field>
      <mat-label>{{ 'labels.inputs.Value' | translate }}</mat-label>
      @if (depositProductIncentiveForm.value.attributeName !== 3) {
        <mat-select formControlName="attributeValue" required>
          @for (attributeValue of attributeValueData; track attributeValue) {
            <mat-option [value]="attributeValue.id">
              {{ attributeValue.name }}
            </mat-option>
          }
        </mat-select>
      }
      @if (depositProductIncentiveForm.value.attributeName === 3) {
        <input type="number" matInput formControlName="attributeValue" required />
      }
      <mat-error>
        {{ 'labels.inputs.Value' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>
  }

  <mat-form-field>
    <mat-label>{{ 'labels.inputs.Type' | translate }}</mat-label>
    <mat-select formControlName="incentiveType" required>
      @for (incentiveType of incentiveTypeData; track incentiveType) {
        <mat-option [value]="incentiveType.id">
          {{ incentiveType.value }}
        </mat-option>
      }
    </mat-select>
    <mat-error>
      {{ 'labels.inputs.Type' | translate }} {{ 'labels.commons.is' | translate }}
      <strong>{{ 'labels.commons.required' | translate }}</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'labels.inputs.Interest' | translate }}</mat-label>
    <input type="number" matInput formControlName="amount" required />
    <mat-error>
      {{ 'labels.inputs.Interest' | translate }} {{ 'labels.commons.is' | translate }}
      <strong>{{ 'labels.commons.required' | translate }}</strong>
    </mat-error>
  </mat-form-field>
</div>

<mat-dialog-actions class="layout-row layout-xs-column layout-align-center gap-2percent">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="{ data: depositProductIncentiveForm }"
    [disabled]="!depositProductIncentiveForm.valid || depositProductIncentiveForm.pristine"
  >
    {{ 'labels.buttons.' + layout.addButtonText | translate }}
  </button>
</mat-dialog-actions>
